import React, { useEffect } from "react";
import "./App.css";
import { useState } from "react";
import NavBar from "./components/NavBar";
import Home from "./components/Home";
import Topics from "./components/Topics";
import Users from "./components/Users";
import Profile from "./components/Profile";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import Footer from "./components/Footer";
import * as buffer from "buffer";
window.Buffer = buffer.Buffer;

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (windowWidth !== window.innerWidth) {
      setWindowWidth(window.innerWidth);
    }
  }, []);
  return (
    <div className="App grid grid-cols-12 gap-2">
      {/* <NavBar/> */}
      {windowWidth < 768 && <WalletMultiButton />}

      <BrowserRouter basename="/">
        <Routes>
          <Route
            element={
              <>
                <NavBar /> <Outlet />
              </>
            }
          >
            <Route path="/" element={<Home />} />
            <Route path="/topic" element={<Topics />}>
              <Route path=":topics" element={<Topics />} />
            </Route>
            <Route path="/user" element={<Users />}>
              <Route path=":userid" element={<Users />} />
            </Route>
            <Route path="/profile" element={<Profile />}>
              <Route path=":profileid" element={<Profile />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
